import movieFrame from '../images/movieFrame.png';

const generateVideoThumbnail = (src: string) => {
    return new Promise(async (resolve: (thumbnail: Blob) => void) => {
        const res = await (await fetch(src)).blob();
        const blobUrl = window.URL.createObjectURL(res);

        const video = document.createElement('video');
        video.src = blobUrl;
    
        const snapshot = async function(){
            var canvas = document.createElement('canvas');
            canvas.width = 50;
            canvas.height = 50;
            var ctx = canvas.getContext('2d');

            const img = new Image();
            img.src = movieFrame;
            img.onload = function () {
                if(ctx !== null)  {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    canvas.toBlob((blob) => {
                        resolve(blob!);
                    })
                    video.removeEventListener('canplay', snapshot);
                }
            };
        };
    
        video.addEventListener('canplay', snapshot);
    })
}

export default generateVideoThumbnail;